export default function Footer() {
  return (
    // <footer>
    //   <div className="container">
    //     <div className="row">
    //       <div
    //         className="col-lg-12 wow fadeIn"
    //         data-wow-duration="1s"
    //         data-wow-delay="0.25s"
    //       >
    //         <p>
    //           © Copyright {new Date().getFullYear()} ACTnet Co. All Rights
    //           Reserved.
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    // </footer>
    <>
      <div className="container-footer pt-5">
        <div className="container-ft">
          <div className="row">
            <div className="clearfix col-md-4 col-sm-12 footer-widget-1">
              <div className="widget-lpinfo">
                <img
                  alt="logo"
                  src="assets/images/ACT.png"
                  className="brand-logo-footer"
                />
              </div>
              <p className="text-white">
                “Driven by Action. Connected by Trust.”
              </p>
            </div>
            <div className="clearfix col-md-4 col-sm-12 footer-widget-2">
              <div
                id="text-4"
                className="footer-widget widget widget_text text-start"
              >
                <h4 className="title">About us</h4>
                <div className="textwidget">
                  <p className="footer-about text-white">
                    ACTnet is a next-generation logistics network built for
                    high-performing freight forwarders. We combine real-world
                    action with intelligent back-office tools to help members
                    grow smarter, faster, and stronger — together.
                  </p>
                </div>
              </div>
            </div>
            <div className="clearfix col-md-4 col-sm-12 footer-widget-3">
              <div
                id="text-5"
                className="footer-widget widget widget_text text-start"
              >
                <h4 className="title">Reach Us</h4>
                <div className="textwidget">
                  <ul className="address">
                    <li>
                      <p>
                        <i className="fa fa-envelope"></i>
                        <a
                          href="mailto:customerservice@actnet.co"
                          className="text-info link-underline-dark"
                        >
                          customerservice@actnet.co
                        </a>
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="widget-social-links d-none d-lg-block ms-lg-4">
                  <a
                    href="#"
                    target="_blank"
                    className="twitter"
                    title="Linkedin"
                  >
                    <img
                      className=""
                      src="assets/images/linked.png"
                      alt="Linkedin logo"
                    />
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    className="facebook"
                    title="Facebook"
                  >
                    <img
                      className=""
                      src="assets/images/x-logo.png"
                      alt="X logo"
                    />
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    className="instagram"
                    title="Instagram"
                  >
                    <img
                      className=""
                      src="assets/images/insta.png"
                      alt="instagram logo"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="site-footer">
        <p>
          {" "}
          © Copyright {new Date().getFullYear()} ACTnet Co. All Rights Reserved.
        </p>
      </footer>
    </>
  );
}
